export default __webpack_public_path__ + "static/media/Coimbatore-Diocese.b362bc5f.png";